const hyphenCaseToCamelCase = (string: string) => {
  return string.replace(/_./g, (word) => word[1].toUpperCase()).replace(/-./g, (word) => word[1].toUpperCase());
};

// Since devs probably expect flags to be in camel case after using LD in the
// frontend, we should convert flags in the extension to match.
const asCamelCaseFlagSet = (flags: Record<string, unknown>) => {
  const updatedFlags = { ...flags };

  for (const [key, value] of Object.entries(updatedFlags)) {
    const camelCaseKey = hyphenCaseToCamelCase(key);

    delete updatedFlags[key];
    updatedFlags[camelCaseKey] = value;
  }

  return updatedFlags;
};

const withOnlyEnabledFlagValues = (flags: Record<string, unknown>) => {
  for (const [key, flag] of Object.entries(flags)) {
    // @ts-expect-error - TODO: replace with proper flagsmith types
    if (flag.enabled) {
      // @ts-expect-error - TODO: replace with proper flagsmith types
      flags[key] = flag.value;
    } else {
      // TODO(BB-80): Revert this if we decide to go for the LD-style approach.
      flags[key] = false;
      // delete flags[key];
    }
  }

  return flags;
};

export const formattedFlags = (flags: Record<string, unknown>) => {
  return withOnlyEnabledFlagValues(asCamelCaseFlagSet(flags));
};
